import React from "react"
import { Box, Typography, styled } from "@mui/material"

import { colors } from "theme"

type Props = {
  children: React.ReactNode
}

const NoticeComponent = ({ children }: Props) => {
  return (
    <Container>
      <Text variant="subtitle2">{children}</Text>
    </Container>
  )
}

export default NoticeComponent

const Container = styled(Box)(() => ({
  backgroundColor: colors.brightGray,
  borderRadius: "21px",
  padding: "10px 20px",
  margin: "24px auto",
  textAlign: "center",
  maxWidth: "860px",
}))

const Text = styled(Typography)(() => ({
  fontWeight: "300",
}))
